import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-24" data-id="element-29" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-30" data-mp="vsmmuobpowcn">
        <div className="mb-12 text-center" data-id="element-31" data-mp="vuh863qwaqh9">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-32" data-mp="qtt8yusij3by">
            Empfohlen
          </p>
          <h2 className="mt-4 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-33" data-mp="14s9mp5oslu3l">
            🎁 5 exklusive Boni
          </h2>
          <p className="mt-4 text-sm text-brand-gray md:text-base" data-id="element-34" data-mp="zsewl4cud8jl">
            Im Wert von über{' '}
            <span className="font-bold text-brand-navy" data-id="element-35" data-mp="1el8curzxtspb">128 €</span> — gratis
            für dich.
          </p>
        </div>
        <div className="space-y-3" data-id="element-36" data-mp="1njsnr6z9ay2z">
          {bonuses.map(bonus => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-line bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-37" data-mp="1nhpp5yk1fwmn">
              <img src={bonus.cover} alt={`Cover Bonus ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-line object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" loading="lazy" data-id="element-38" data-mp="3pses4l7ni0hz" />
              <div className="min-w-0 flex-1" data-id="element-39" data-mp="7ma4kayc9zpt">
                <h3 className="font-bold leading-snug text-brand-navy" data-id="element-40" data-mp="ck1u4ybih9qu">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-brand-gray sm:text-sm" data-id="element-41" data-mp="gkc0ic37u268">
                  {bonus.description}
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-42" data-mp="qb6xobi02m6g">
                <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-brand-gray" data-id="element-43" data-mp="qaousw0u19pk">
                  Wert
                </p>
                <p className="font-display text-lg font-extrabold text-brand-orange" data-id="element-44" data-mp="109e3by6u9ht5">
                  {bonus.value}
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}